import { allows } from '@/core/router/utils'

export default {
  name: 'global-mixin',

  methods: {

    msgBoxConfirm(text = 'Are you sure?', params = {}) {

      const defaultParams = {
        title: 'Decline',
        size: 'md',
        buttonSize: 'sm',
        okVariant: 'primary',
        okTitle: 'Ok',
        cancelTitle: 'Cancel',
        cancelVariant: 'outline-primary',
        modalClass: 'delete-modal',
        hideHeaderClose: true,
        centered: true,
      }

      params = { ...defaultParams, ...params }

      return new Promise((resolve, reject) => {
        this.$bvModal
        .msgBoxConfirm(text, params)
        .then((value) => {
          if (value) {
            return resolve()
          }
          return reject()
        }).catch( () => {
          return reject()
        })
      })

    },

    contactSupport(error = null) {
      const defaultMsg = `An unknown error occurred, please contact ${
        process.env.VUE_APP_SUPPORT_EMAIL_ADDRESS
      } if the problem persists.`
      let errorMsg = defaultMsg

      if (typeof error === 'string') {
        errorMsg = error
      } else if (error?.response) {
        const status = error.response.status
        const data = error.response.data || {}
        const errors = data.errors || {}

        if (status === 401) {
          errorMsg = 'Session has expired. Please log in again.'
        } else if (status === 422) {
          errorMsg = data.message || data.error?.message || defaultMsg
          const fieldMsg = errors.children?.[0]
            || errors.email_address?.[0]
            || errors.email?.[0]
            || errors.contact_phone?.[0]
            || errors.cs_number?.[0]
          if (fieldMsg) errorMsg = fieldMsg
        } else if (status === 403) {
          errorMsg = data.message || data.error?.message || defaultMsg
        } else if (status === 409) {
          errorMsg = data.error?.message || data.message || defaultMsg
        } else if (status === 500) {
          errorMsg = data.message || defaultMsg
        } else if (data.code === 4040) {
          errorMsg = data.message || defaultMsg
        }
      } else if (error?.data?.error) {
        errorMsg = error.data.error.message || defaultMsg
      }

      if (errorMsg) {
        this.$bus.emit('app::alert::error', errorMsg)
      }
    },

    allows: allows,
  },
}
